module.exports = __webpack_public_path__ + "static/3570-6d1144cb29e4b88d66b1722f6ca1aee2.pdf";